import { applyMiddleware, compose, createStore } from 'redux';
import gaTrackerMiddleware from 'config/analytics';
import reducer from 'reducers';
import promiseMiddleware from 'config/promiseMiddleware';

const middlewares = [applyMiddleware(promiseMiddleware, gaTrackerMiddleware)];

const initialize = (initialState = {}) => {
  const store = createStore(reducer, initialState, compose(...middlewares));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers'); // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }
  return store;
};

export default initialize;
